import React from 'react';
import styles from './CalendarPopup.module.scss';

type CalendarPopupProps = {
    url: string | undefined;
};

const CalendarPopup: React.FC<CalendarPopupProps> = ({ url }) => {
    if (!url) return null;
    return (
        <div className={styles.root}>
            <iframe src={url} style={{ border: 0 }} width="100%" min-width="300px" height="100%" />
        </div>
    );
};

export default CalendarPopup;
